export enum SingleChangeEditableFields {
  title = 'title',
  singleDate = 'singleDate',
  addAttachment = 'addAttachment',
  editAttachment = 'editAttachment',
  addLink = 'addLink',
  editLink = 'editLink'
}
